import React, { type PropsWithChildren, memo } from "react";
import DisclosureVariant, { type DisclosureVariants } from "./Disclosure.styles";

export type DisclosureVariantsType = keyof typeof DisclosureVariants;

type DisclosureProps = {
    variant: DisclosureVariantsType;
    ariaLabel?: string;
    open?: boolean;
};

const Disclosure: React.FC<PropsWithChildren<DisclosureProps>> = (props) => {
    const { variant, ariaLabel, open, children } = props;
    return (
        <DisclosureVariant aria-label={ariaLabel} variant={variant} open={open}>
            {children}
        </DisclosureVariant>
    );
};

export default memo(Disclosure);
